exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiLevelSelector__wrapper___QzsUH {\n  margin-inline: -7px;\n  position: relative; }\n  @media (max-width: 768px) {\n    .multiLevelSelector__wrapper___QzsUH {\n      margin: 0; } }\n\n.multiLevelSelector__selector___1UsYA {\n  display: inline-block;\n  padding-inline: 7px; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "multiLevelSelector__wrapper___QzsUH",
	"selector": "multiLevelSelector__selector___1UsYA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiLevelSelector/multiLevelSelector.scss
// module id = 2103
// module chunks = 6